import { LegislationApi } from '@core/api'

export default {
    data() {
        return {
            legislationTranslations: [],
            legislationTranslationsLoaded: false,
        }
    },
    methods: {
        getLegislationInfoTranslationHeader(id) {
            const translation = this.legislationTranslations.find(t => t.id === id)

            if (translation) {
                return translation.legislation && translation.legislation.header ? translation.legislation.header : null
            }

            return null
        },
        getLegislationInfoTranslation(id) {
            const translation = this.legislationTranslations.find(t => t.id === id)

            if (translation) {
                return translation.legislation && translation.legislation.info ? translation.legislation.info : null
            }

            return null
        },
        getLegislationSubstanceListInfoTranslation(substanceListId) {
            const translation = this.legislationTranslations.find(t => t.list && t.list.id === substanceListId)

            if (translation) {
                return translation.list && translation.list.info ? translation.list.info : null
            }

            return null
        },
        hasLegislationInfoTranslation(id) {
            const translation = this.legislationTranslations.find(t => t.id === id)

            if (translation) {
                return !!(translation.legislation && translation.legislation.header)
            }

            return false
        },
        hasLegislationSubstanceListInfoTranslation(substanceListId) {
            const translation = this.legislationTranslations.find(t => t.list && t.list.id === substanceListId)

            if (translation) {
                return translation.list && translation.list.info !== null && translation.list.info.length > 0
            }

            return false
        },

    },
    created() {
        LegislationApi.getTranslations().then(r => {
            this.legislationTranslations = r.data
            this.legislationTranslationsLoaded = true
        })
    },
}
